<template>
  <div class="mall-month-data-detail1">
    <div class="detail-content">
      <div class="detail-content__left">
        <div class="chart-wrapper">
          <div class="chart-item">
            <div class="chart-title">
              订单收益
            </div>
            <div class="chart-content">
              <MallMonthDataDetailChart1
                :list="chartList1"
                bar-name="订单量"
                line-name="当月累计收益"
                color="#1261FF"
              />
            </div>
          </div>
          <div class="chart-item">
            <div class="chart-title">
              <span>会员收益</span><el-tooltip
                effect="dark"
                placement="top"
              >
                <div slot="content">
                  会员收益按月统计，展示收益为当月累计收益。
                </div>
                <i
                  class="eqf-why-l"
                ></i>
              </el-tooltip>
            </div>
            <div class="chart-content">
              <MallMonthDataDetailChart1
                :list="chartList2"
                :bar-name="barName"
                line-name="当月累计收益"
                color="#FFA000"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="detail-content__line"></div>
      <div class="detail-content__right">
        <!-- 等级 -->
        <section class="level-wrapper">
          <div class="detail-title">
            等级
          </div>
          <div class="level">
            <div class="level-info">
              <div class="level-info-item">
                上月历史积分：<span>{{ lastMonthIntegration }}</span>、上月等级：<span>Lv{{ lastMonthLevel }}</span>
              </div>
              <div class="level-info-item">
                当月积分：<span>{{ monthIntegration }}</span>、当月等级：<span>Lv{{ monthLevel }}</span>
              </div>
            </div>
            <div class="level-progress">
              <div class="progress-line"></div>
              <div
                :style="{ left: getLevelPos(6) }"
                class="progress-node6"
              >
                <div class="node"></div>
                <div class="text">
                  6级
                </div>
              </div>
              <div
                :style="{ left: getLevelPos(10) }"
                class="progress-node10"
              >
                <div class="node"></div>
                <div class="text">
                  10级
                </div>
              </div>
              <div
                :style="{ left: getLevelPos(20) }"
                class="progress-node20"
              >
                <div class="node"></div>
                <div class="text">
                  20级
                </div>
              </div>
              <div
                v-show="levelVisible"
                :style="{ left: getLevelPos(monthLevel) }"
                class="progress-value"
              >
                <div class="progress-value__line"></div>
                <div class="progress-value__node"></div>
              </div>
            </div>
            <div class="tips">
              <span
                v-show="levelVisible && tips"
                :style="getTipsPos(monthLevel)"
                class="tips-text"
              >{{ tips }}</span>
              <a
                href="//help.eqxiu.com/doc/710/"
                target="_blank"
                style="display: flex;align-items:center"
              >
                <span class="tips-link">秀客评级规则详见</span><i class="eqf-right"></i>
              </a>
            </div>
            <div class="level-intro">
              <div
                :class="{ vip0: monthLevel >= 0 }"
                class="level-intro__item"
              >
                <div class="icon"></div>
                <div class="percent">
                  <div class="percent-text">
                    分成比例
                  </div>
                  <div class="percent-text">
                    {{ shareRatio['0'][data.key] || shareRatio['0'].other }}
                  </div>
                </div>
                <div class="text">
                  0级解锁
                </div>
              </div>
              <div
                :class="{ vip6: monthLevel >= 6 }"
                class="level-intro__item"
              >
                <div class="icon"></div>
                <div class="percent">
                  <div class="percent-text">
                    分成比例
                  </div>
                  <div class="percent-text">
                    {{ shareRatio['6'][data.key] || shareRatio['6'].other }}
                  </div>
                </div>
                <div class="text">
                  6级解锁
                </div>
              </div>
              <div
                :class="{ vip10: monthLevel >= 10 }"
                class="level-intro__item"
              >
                <div class="icon"></div>
                <div class="percent">
                  <div class="percent-text">
                    分成比例
                  </div>
                  <div class="percent-text">
                    {{ shareRatio['10'][data.key] || shareRatio['10'].other }}
                  </div>
                </div>
                <div class="text">
                  10级解锁
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- 积分规则 -->
        <section class="rule-wrapper">
          <div class="detail-title">
            获得积分去升级
          </div>
          <div class="rule">
            <div class="rule-item">
              <div class="rule-item__header">
                基础分数
              </div>
              <div class="rule-item__list">
                <div
                  v-for="item in rule[data.key] || []"
                  :key="item.name"
                  class="list-item">
                  <div class="item-main">
                    <span>{{ item.name }}</span>
                    <span class="num">{{ item.value }}</span>
                  </div>
                  <div v-if="item.desc" class="item-desc">{{ item.desc }}</div>
                </div>
              </div>
            </div>
            <div class="rule-item">
              <div class="rule-item__header">
                <span>加减分项</span>
              </div>
              <div class="rule-item__list">
                <div
                  v-for="item in extraRule"
                  :key="item.name"
                  class="list-item">
                  <div
                    v-if="!(data.key === 'video' && item.name === '免费模板')"
                    class="item-main">
                    <span>{{ item.name }}</span>
                    <span class="num">{{ item.value }}</span>
                  </div>
                  <div v-if="item.desc" class="item-desc">
                    {{ item.desc }}
                    <a
                      v-if="item.linkName"
                      :href="item.linkHref"
                      class="link"
                      target="_blank"
                      rel="noopener noreferrer">
                      {{ item.linkName }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="rule-item">
              <div class="rule-item__header">
                特殊说明
              </div>
              <div class="rule-item__list">
                <div class="list-item inline">
                  当月新增模板量>0 参与评级
                </div>
                <div class="list-item inline">
                  当月新增模板量=0 则当月积分及等级为0
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { getSpecificIncome } from 'src/api/showker'
import MallMonthDataDetailChart1 from './MallMonthDataDetailChart1'

export default {
  name: 'MallMonthDataDetail1',
  components: {
    MallMonthDataDetailChart1
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    showkerId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      chartList1: [],
      chartList2: [],
      // 等级积分
      lastMonthIntegration: 0,
      lastMonthLevel: 0,
      monthIntegration: 0,
      monthLevel: 0,
      level6: 75,
      level10: 150,
      level20: 300,
      levelVisible: false,
      // 等级积分规则
      rule: {
        h5: [
          { name: '常规模板', value: '1分/个', desc: '（常规模板60分封顶）'},
          { name: '可商用模板', value: '3分/个' },
          { name: '模板订单量', value: '0.1分/个' },
          { name: '会员使用量', value: '0.2分/次' },
          { name: '历史积分', value: '0.1分/分' }
        ],
        h2: [
          { name: '常规模板', value: '1分/个' },
          { name: '可商用模板', value: '3分/个' },
          { name: '会员使用量', value: '0.1分/次' },
          { name: '历史积分', value: '0.1分/分' }
        ],
        h5l: [
          { name: '可商用模板', value: '3分/个' },
          { name: '会员使用量', value: '0.2分/次' },
          { name: '历史积分', value: '0.1分/分' }
        ],
        video: [
          { name: '常规模板', value: '1分/个'},
          { name: '可商用模板', value: '3分/个' },
          { name: '会员使用量', value: '0.1分/次' },
          { name: '历史积分', value: '0.1分/分' }
        ]
      },
      // 加减分项
      extraRule: [
        { name: '原创模板', value: '+1分/个' },
        { name: '严选模板', value: '+1分/个' },
        { name: '免费模板', value: '+0.5分/个' },
        { name: '其他加分', value: '以任务/活动详情为准' },
        { name: '秀客黑名单B类', value: '-20分', desc: '*详情参考', linkName: '《易企秀秀客行为管理规范》', linkHref: '//help.eqxiu.com/doc/694/' },
      ]
    }
  },
  computed: {
    tips() {
      let nextLevel = 6
      let diff = 0
      if (this.monthLevel < 6) {
        nextLevel = 6
        diff = this.level6 - this.monthIntegration
      } else if (this.monthLevel >= 6 && this.monthLevel < 10) {
        nextLevel = 10
        diff = this.level10 - this.monthIntegration
      } else if (this.monthLevel >= 10 && this.monthLevel < 20) {
        nextLevel = 20
        diff = this.level20 - this.monthIntegration
      } else {
        return ''
      }

      return `还有${diff.toFixed(2)}分就可以达到lv${nextLevel}啦！加油哦~`
    },
    barName() {
      if (['h5', 'h5l'].includes(this.data.key)) {
        return '使用量'
      }
      if (['h2', 'video'].includes(this.data.key)) {
        return '下载量'
      }
      return ''
    },
    shareRatio() {
      return {
        '0': {
          video: '32%',
          h5l: '7.5%',
          other: '15%'
        },
        '6': {
          video: '36%',
          h5l: '10%',
          other: '20%'
        },
        '10': {
          video: '40%',
          h5l: '15%',
          other: '30%'
        }
      }
    }
  },
  mounted() {
    this.getChartData()
  },
  methods: {
    async getChartData() {
      this.levelVisible = false
      const groupId = {
        h5: 2,
        h2: 7,
        h5l: 10,
        video: 15,
        gc: 14,
        h5e: 11
      }
      try {
        const { data } = await getSpecificIncome({
          showkerId: this.showkerId,
          attrGroupId: groupId[this.data.key]
        })
        if (data && data.obj) {
          const { rankPoint, orderDataList, vipDataList } = data.obj
          // 积分
          if (rankPoint) {
            this.lastMonthIntegration = rankPoint.showkerHistoryPoint
            this.lastMonthLevel = rankPoint.showkerBefoRank
            this.monthIntegration = rankPoint.showkerRankPoint
            this.monthLevel = rankPoint.showkerRank
            this.level6 = rankPoint.showkerSixRank
            this.level10 = rankPoint.showkerTenRank
            this.level20 = rankPoint.showkerTwentyRank
            this.levelVisible = true
          }
          // 订单收益
          if (orderDataList && orderDataList.length) {
            this.chartList1 = orderDataList.map(item => {
              return {
                date: item.dateTime,
                barValue: item.orderNumber,
                lineValue: +(item.todayAllIncome / 100).toFixed(2)
              }
            })
          }

          // 会员收益
          if (vipDataList && vipDataList.length) {
            this.chartList2 = vipDataList.map(item => {
              return {
                date: item.dateTime,
                barValue: item.orderNumber,
                lineValue: +(item.todayAllIncome / 100).toFixed(2)
              }
            })
          }
        }
      } catch (e) {
        throw e
      }
    },
    // 获取level节点位置
    getLevelPos(level) {
      const left = level / 20 * 60
      if (level > 20) {
        let maxLevel = left > 100 ? 100 : left
        return maxLevel + '%'
      }

      return left + '%'
    },
    getTipsPos(level) {
      const left = level / 20 * 60
      if (level <= 6) {
        return {
          left: '0%'
        }
      }

      if (level >= 20) {
        return {
          display: 'none'
        }
      }

      return {
        left: left + '%',
        transform: 'translate(-50%, 0)'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mall-month-data-detail1 {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    overflow: auto;
    border: 1px solid #E6EBED;
    border-radius: 4px;

    &::-webkit-scrollbar {
      width: 7px;
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background-color: rgba(0, 0, 0, 0.2);
    }

    .eqf-why-l {
      display: inline-block;
      font-size: 14px;
      color: #999;
      margin-left: 4px;
      margin-top: 1px;

      &:hover {
        color: #666;
      }
    }

    .detail-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }

    .detail-content {
        width: 100%;
        height: 100%;
        min-height: 648px;
        padding: 40px;
        display: flex;

        &__left {
            width: 50%;

            .chart-wrapper {
              width: 100%;
              height: 100%;

              .chart-item {
                width:  100%;
                height: calc(50% - 20px);

                &:not(:first-child) {
                  margin-top: 40px;
                }

                .chart-title {
                  display: flex;
                  align-items: center;
                  @extend .detail-title;
                }

                .chart-content {
                  height: calc(100% - 20px);
                }
              }
            }
        }

        &__line {
          width: 1px;
          background-color: #E6EBED;
        }

        &__right {
            width: 50%;
            padding-left: 40px;

            // .level-wrapper {
            //   height: 56%;
            // }

            .rule-wrapper {
              // height: 44%;
              margin-top: 40px;
            }

            .level {
              margin-top: 20px;

              .level-info {
                &-item {
                  font-size: 12px;
                  color: #999;

                  &:not(:first-child) {
                    margin-top: 12px;
                  }

                  span {
                    color: #1261FF;
                  }
                }
              }

              .level-progress {
                width: 100%;
                margin-top: 16px;
                position: relative;
                height: 45px;

                .progress-line {
                  position: absolute;
                  top: 12px;
                  width: 100%;
                  height: 2px;
                  background: linear-gradient(90deg, #fff 0%, #FFA000 5%, #FFA000 95%, #fff 100%);
                }

                .progress-node6,
                .progress-node10,
                .progress-node20 {
                  position: absolute;
                  top: 7px;
                  z-index: 1;

                  .node {
                    width: 12px;
                    height: 12px;
                    border-radius: 50%;
                    border: 1px solid #FFA000;
                    background-color: #fff;
                    margin-bottom: 8px;
                    transform: translate(-50%, 0);
                  }

                  .text {
                    font-size: 12px;
                    color: #999;
                    transform: translate(-50%, 0);
                  }
                }

                .progress-value {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 7px;
                  height: 44px;
                  transform: translate(-50%, 0);
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  // transition: left .3s;

                  &__line {
                    width: 1px;
                    height: 38px;
                    background-color: #FFA000;
                  }

                  &__node {
                    width: 7px;
                    height: 7px;
                    border-radius: 50%;
                    background-color: #FFA000;
                  }
                }

              }
              .tips {
                position: relative;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 4px;

                .tips-text {
                  position: absolute;
                  display: inline-block;
                  height: 24px;
                  line-height: 24px;
                  padding: 0 8px;
                  background-color: #FEEFD0;
                  border-radius: 4px;
                  font-size: 12px;
                  white-space: nowrap;
                  color: #666;
                }

                .tips-link {
                  font-size: 12px;
                  color: #1261FF;

                  &:hover {
                    text-decoration: underline;
                  }
                }
                .eqf-right {
                  display: inline-block;
                  font-size: 14px;
                  color: #1261FF;
                }
              }
              .level-intro {
                display: inline-flex;
                padding: 0 16px;
                margin-top: 24px;

                &__item {
                  display: flex;
                  flex-direction: column;
                  align-items: center;

                  &:not(:first-child) {
                    margin-left: 28px;
                  }
                }

                .icon {
                  width: 36px;
                  height: 36px;
                  background: url('~src/img/vip0.png') no-repeat;
                  background-size: 100% 100%;
                }

                .percent {
                  margin: 8px 0;

                  &-text {
                    height: 12px;
                    color: #999;
                    font-size: 12px;
                    text-align: center;

                    &:not(:first-child) {
                      margin-top: 4px;
                    }
                  }
                }

                .text {
                  width: 58px;
                  height: 16px;
                  line-height: 14px;
                  font-size: 12px;
                  color: #B6B6B6;
                  text-align: center;
                  border: 1px solid #E0E0E0;
                  border-radius: 4px;
                }

                .level-intro__item.vip0 {
                  .icon {
                    background: url('~src/img/vip1.png') no-repeat;
                    background-size: 100% 100%;
                  }
                  .percent-text {
                    color: #333;
                  }
                }

                .level-intro__item.vip6 {
                  .icon {
                    background: url('~src/img/vip2.png') no-repeat;
                    background-size: 100% 100%;
                  }
                  .percent-text {
                    color: #333;
                  }
                }

                .level-intro__item.vip10 {
                  .icon {
                    background: url('~src/img/vip3.png') no-repeat;
                    background-size: 100% 100%;
                  }
                  .percent-text {
                    color: #333;
                  }
                }
              }
            }

            .rule {
              margin-top: 20px;
              display: flex;

              &-item {
                flex: 1;
                border: 1px solid #E6EBED;
                border-radius: 4px;
                padding: 20px 20px 36px 20px;

                &:not(:first-child) {
                  margin-left: 20px;
                }

                &:nth-child(1) {
                  min-width: 172px;
                }

                &:nth-child(2) {
                  min-width: 192px;
                }

                &__header {
                  font-size: 14px;
                  font-weight: bold;
                  color: #333;
                  margin-bottom: 28px;
                  display: flex;
                  align-items: center;
                }

                &__list {
                  .list-item {
                    &:not(:first-child) {
                      margin-top: 12px;
                    }

                    &.inline {
                      display: block;
                    }

                    .item-main {
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      font-size: 12px;
                      line-height: 16px;
                      color: #666;
                    }

                    .item-desc {
                      font-size: 12px;
                      color: #999;
                      margin-top: 2px;
                    }

                    .num {
                      color: #333;
                    }

                    .link {
                      color: #1261FF;

                      &:hover {
                        text-decoration: underline;
                      }
                    }
                  }
                }
              }
            }
        }
    }
}
</style>
